module.exports = __webpack_public_path__ + "static/media/nift.dcd17d5e.png";